/* kn-variant-buy.js — 20/10/2026
   Che do mua "theo hang bien the" (chon 1 trong cac bien the, kem so luong): moi bien the (vd Facial Mask / Combo Facial Mask) la mot hang
   [anh] [ten + gia] [o so luong], thay cho hai khoi "Set" (swatch) va "Choose your pack" (the pack).
   Bat theo tung san pham bang metafield custom.buy_mode = "variants" (meta-tags.liquid doc ->
   window.KN_PRODUCT.buyMode, dong thoi an .kp-field ngay tu <head> de khong nhay).
   Du lieu lay tu #kp-data (kv-product.liquid): variants[{id,title,options,available,price,compare,off,image,imageLarge}].
   Nut ADD TO CART cua theme duoc giu nguyen; script bat click o pha capture de tu them cac hang co so luong > 0
   roi chuyen sang /cart (giong kn-product.js). Nut SHOP NOW (checkout thang) chi hien khi chon dung 1 bien the. */
(function () {
  var cfg = window.KN_PRODUCT || {};
  if (cfg.buyMode !== 'variants') return;
  var root = document.querySelector('.kp'), dataEl = document.getElementById('kp-data');
  if (!root || !dataEl) return;
  var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var variants = data.variants || []; if (!variants.length) return;
  var buy = root.querySelector('.kp-buy') || root;
  var fields = buy.querySelectorAll('.kp-field');
  var priceBox = buy.querySelector('.kp-price');
  var anchor = fields[0] || (priceBox && priceBox.nextSibling);
  var MAX = 10;

  function num(s) { if (s == null) return 0; var n = parseFloat(String(s).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
  var cur = (String(variants[0].price || '$').match(/^[^0-9]*/) || ['$'])[0];
  function money(n) { return cur + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var qty = {};
  variants.forEach(function (v, i) {
    var def = (data.selected != null ? v.id === data.selected : i === 0);
    qty[v.id] = def && v.available ? 1 : 0;
  });

  var style = document.createElement('style');
  style.textContent =
    '.kv-rows{margin:14px 0 4px}' +
    '.kv-rows .kp-field-hd{display:flex;justify-content:space-between;align-items:baseline;gap:10px}' +
    '.kv-rows-hint{font-weight:400;color:#6b7280;font-size:13px}' +
    '.kv-row{display:flex;flex-wrap:wrap;align-items:center;gap:12px;padding:12px;border:1px solid #e3e3e3;border-radius:12px;margin-top:10px;background:#fff;cursor:pointer}' +
    '.kv-row.is-on{border-color:var(--kn-accent,#1f5fe0);box-shadow:inset 0 0 0 1px var(--kn-accent,#1f5fe0)}' +
    '.kv-row.is-out{opacity:.55;cursor:default}' +
    '.kv-img{width:64px;height:64px;border-radius:8px;object-fit:cover;flex:0 0 64px;background:#f3f3f3}' +
    '.kv-info{flex:1 1 230px;min-width:0;padding-right:4px}' +
    '.kv-name{font-weight:700;color:#121212;font-size:15px;line-height:1.3}' +
    '.kv-price{margin-top:4px;font-size:14px;color:#3d3d3d;line-height:1.4;display:flex;flex-wrap:wrap;align-items:baseline;column-gap:6px;row-gap:3px}.kv-price b{font-size:17px;color:#121212}.kv-price s{color:#8a8a8a}' +
    '.kv-pp{white-space:nowrap;display:inline-flex;align-items:baseline;gap:6px}' +
    '.kv-price em{font-style:normal;padding:2px 7px;border-radius:999px;background:#fde8e0;color:#c2410c;font-size:12px;font-weight:700;white-space:nowrap}' +
    '.kv-note{margin-top:4px;font-size:12.5px;color:#6b7280;line-height:1.45}' +
    '.kv-out{font-size:12px;color:#b91c1c;font-weight:700;margin-top:3px}' +
    '.kv-qty{display:flex;align-items:center;border:1px solid #d9d9d9;border-radius:999px;overflow:hidden;flex:0 0 auto;margin-left:auto;background:#fff}' +
    '.kv-qty button{width:34px;height:36px;border:0;background:#fff;font-size:20px;line-height:1;cursor:pointer;color:#121212;padding:0}' +
    '.kv-qty button:disabled{color:#c4c4c4;cursor:default}' +
    '.kv-qty input{width:36px;height:36px;border:0;text-align:center;font-size:15px;font-weight:700;color:#121212;background:#fff;-moz-appearance:textfield;padding:0}' +
    '.kv-qty input::-webkit-outer-spin-button,.kv-qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}' +
    '.kv-sum{display:flex;justify-content:space-between;align-items:baseline;margin-top:12px;padding-top:10px;border-top:1px solid #ededed;font-size:14px;color:#3d3d3d}' +
    '.kv-sum b{font-size:18px;color:#121212}.kv-sum s{color:#8a8a8a;margin-left:6px}.kv-sum small{color:#6b7280}' +
    '.kv-tier{margin:10px 0 0;padding-top:10px;border-top:1px solid #ededed;font-size:13px;color:#6b7280;line-height:1.5}' +
    '@media (max-width:480px){.kv-rows-hint{display:none}.kv-info{flex-basis:170px}.kv-img{width:56px;height:56px;flex-basis:56px}.kv-name{font-size:14px}.kv-price b{font-size:16px}.kv-qty button{width:30px}.kv-qty input{width:32px}}';
  document.head.appendChild(style);

  var notes = (cfg.variantNotes && typeof cfg.variantNotes === 'object') ? cfg.variantNotes : {}; /* 20/10: metafield bien the custom.includes, do meta-tags.liquid xuat ra */
  function row(v) {
    var q = qty[v.id] || 0;
    return '<div class="kv-row' + (q > 0 ? ' is-on' : '') + (v.available ? '' : ' is-out') + '" data-vid="' + v.id + '">' +
      (v.image ? '<img class="kv-img" src="' + esc(v.image) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="kv-img"></span>') +
      '<div class="kv-info"><div class="kv-name">' + esc(v.title || (v.options || []).join(' / ')) + '</div>' +
      '<div class="kv-price"><span class="kv-pp"><b>' + esc(v.price) + '</b>' + (v.compare ? '<s>' + esc(v.compare) + '</s>' : '') + '</span>' + (v.off ? '<em>−' + v.off + '%</em>' : '') + '</div>' +
      (notes[v.id] ? '<div class="kv-note">' + esc(notes[v.id]) + '</div>' : '') +
      (v.available ? '' : '<div class="kv-out">' + esc(data.soldOut || 'Sold out') + '</div>') + '</div>' +
      '<div class="kv-qty"><button type="button" data-kv-dec aria-label="Decrease quantity"' + (v.available ? '' : ' disabled') + '>−</button>' +
      '<input type="number" inputmode="numeric" min="0" max="' + MAX + '" value="' + q + '" data-kv-q aria-label="Quantity: ' + esc(v.title) + '"' + (v.available ? '' : ' disabled') + '>' +
      '<button type="button" data-kv-inc aria-label="Increase quantity"' + (v.available ? '' : ' disabled') + '>+</button></div></div>';
  }

  var wrap = document.createElement('div');
  wrap.className = 'kv-rows';
  wrap.innerHTML =
    '<div class="kp-field-hd"><span>' + esc(cfg.buyModeLabel || 'Choose your set') + '</span><span class="kv-rows-hint">Pick one option, then the quantity</span></div>' +
    variants.map(row).join('') +
    /* 20/10: user bo dong Total (gia tong) duoi danh sach */
    '<p class="kv-tier">' + esc(cfg.buyModeTier || 'Buy 2 save 10% · 3 save 15% · 4+ save 20% — taken off automatically at checkout.') + '</p>';
  if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor); else buy.appendChild(wrap);
  fields.forEach(function (f) { f.style.display = 'none'; });

  var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });
  var shopWrap = root.querySelector('[data-shop]'), shopNote = root.querySelector('[data-shop-note]');
  var idInput = root.querySelector('[data-variant-input]'), qtyInput = root.querySelector('[data-qty-input]');
  var mainImg = document.getElementById('kp-img');

  function items() {
    return variants.filter(function (v) { return (qty[v.id] || 0) > 0; }).map(function (v) { return { id: Number(v.id), quantity: qty[v.id] }; });
  }

  function paint() {
    var total = 0, compare = 0, units = 0, chosen = items();
    chosen.forEach(function (it) { var v = byId[it.id]; total += num(v.price) * it.quantity; compare += num(v.compare || v.price) * it.quantity; units += it.quantity; });
    wrap.querySelectorAll('.kv-row').forEach(function (r) { var q = qty[r.dataset.vid] || 0; r.classList.toggle('is-on', q > 0); var inp = r.querySelector('[data-kv-q]'); if (inp && Number(inp.value) !== q) inp.value = q; var dec = r.querySelector('[data-kv-dec]'); if (dec && byId[r.dataset.vid].available) dec.disabled = q <= 0; });
    var tEl = wrap.querySelector('[data-kv-total]'), cEl = wrap.querySelector('[data-kv-compare]');
    if (tEl) tEl.textContent = units ? money(total) : money(0);
    if (cEl) { var showC = units > 0 && compare > total + 0.004; cEl.hidden = !showC; cEl.textContent = showC ? money(compare) : ''; }
    /* gia lon dau khoi mua: 1 bien the x1 -> gia bien the; con lai -> tong */
    if (priceBox) {
      var pEl = priceBox.querySelector('strong'), wEl = priceBox.querySelector('s'), oEl = priceBox.querySelector('.kp-off');
      if (units === 0) { var f = variants[0]; if (pEl) pEl.textContent = f.price; if (wEl) { wEl.textContent = f.compare || ''; wEl.hidden = !f.compare; } if (oEl) { oEl.textContent = '−' + f.off + '%'; oEl.hidden = !f.off; } }
      else { if (pEl) pEl.textContent = money(total); var hasC = compare > total + 0.004; if (wEl) { wEl.textContent = hasC ? money(compare) : ''; wEl.hidden = !hasC; } if (oEl) { var off = hasC ? Math.round((1 - total / compare) * 100) : 0; oEl.textContent = '−' + off + '%'; oEl.hidden = !off; } }
    }
    var single = chosen.length === 1;
    if (idInput && single) idInput.value = chosen[0].id;
    if (qtyInput && single) qtyInput.value = chosen[0].quantity;
    if (shopWrap) shopWrap.hidden = !single;
    if (shopNote) shopNote.hidden = true;
    var btn = root.querySelector('.kp-add');
    if (btn) { btn.disabled = units === 0; if (units === 0) btn.textContent = cfg.buyModePick || 'CHOOSE A QUANTITY'; else if (btn.textContent !== (data.addingLabel || 'Adding…')) btn.textContent = data.addLabel || 'ADD TO CART'; }
  }

  function setQty(id, q, showImg) {
    var v = byId[id]; if (!v || !v.available) return;
    q = Math.max(0, Math.min(MAX, Math.round(Number(q) || 0)));
    var was = qty[id] || 0; qty[id] = q;
    /* 20/10: hai lua chon LOAI TRU nhau — chon ban nay thi ban kia ve 0 (chi con chinh so luong cho ban da chon) */
    if (q > 0) variants.forEach(function (o) { if (String(o.id) !== String(id)) qty[o.id] = 0; });
    if (showImg && was === 0 && q > 0 && mainImg && v.imageLarge) mainImg.src = v.imageLarge;
    paint();
  }

  wrap.addEventListener('click', function (e) {
    var r = e.target.closest('.kv-row'); if (!r) return;
    var id = r.dataset.vid;
    if (e.target.closest('[data-kv-inc]')) { setQty(id, (qty[id] || 0) + 1, true); return; }
    if (e.target.closest('[data-kv-dec]')) { setQty(id, (qty[id] || 0) - 1, false); return; }
    if (e.target.closest('input')) return;
    /* bam vao hang chua chon -> chon 1 */
    if ((qty[id] || 0) === 0) setQty(id, 1, true);
  });
  wrap.addEventListener('change', function (e) { var inp = e.target.closest('[data-kv-q]'); if (!inp) return; var r = inp.closest('.kv-row'); setQty(r.dataset.vid, inp.value, true); });
  wrap.addEventListener('input', function (e) { var inp = e.target.closest('[data-kv-q]'); if (!inp || inp.value === '') return; var r = inp.closest('.kv-row'); setQty(r.dataset.vid, inp.value, false); });

  /* Chiem nut ADD TO CART cua theme (pha capture, truoc kn-product.js) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kp-add'); if (!btn || !root.contains(btn)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (btn.disabled) return;
    var list = items(); if (!list.length) { paint(); return; }
    var original = btn.textContent; btn.disabled = true; btn.textContent = data.addingLabel || 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = original; });
  }, true);

  paint();
})();
